/**
 * Enum for the ACTIONS - feel free to add some more if you need
 */
export var ACTION;
(function (ACTION) {
    ACTION["close"] = "close";
    ACTION["show"] = "show";
    ACTION["click"] = "click";
    ACTION["delete"] = "delete";
    ACTION["check"] = "check";
    ACTION["uncheck"] = "uncheck";
    ACTION["clear"] = "clear";
    ACTION["change"] = "change";
    ACTION["changeView"] = "change_view";
    ACTION["callback"] = "callback";
    ACTION["play"] = "play";
    ACTION["startGame"] = "startGame";
    ACTION["startMatching"] = "startMatching";
    ACTION["cancelMatching"] = "cancelMatching";
    ACTION["demoGameResult"] = "demoGameResult";
    ACTION["autoCookieConsent"] = "consent";
    ACTION["autoCookieContinued"] = "continued";
})(ACTION || (ACTION = {}));
//# sourceMappingURL=ACTION.js.map